import { FormControlLabel, Switch } from "@mui/material";
import { forwardRef, useMemo } from "react";
import { MetadataInputProps } from "../metadata-input-index";

type LocalizedBoolMetadataInfos = {
  cultureId: number;
  language: string;
  value: boolean;
  epNb?: number | null;
};

type LocalizedBoolMetadataInfosIndexed = {
  index: number;
  data: LocalizedBoolMetadataInfos;
};

const MetadataInputBoolMultiLocalized = forwardRef<any, MetadataInputProps>((props, ref) => {
  const { onChange, data, value, cultureId, epNb } = props;

  const localized = useMemo((): LocalizedBoolMetadataInfosIndexed => {
    return {
      index: (value as LocalizedBoolMetadataInfos[]).findIndex((x) => x.cultureId === cultureId && x.epNb === epNb),
      data: (value as LocalizedBoolMetadataInfos[]).find((x) => x.cultureId === cultureId && x.epNb === epNb)!,
    };
  }, [value, cultureId, epNb]);

  return (
    <FormControlLabel
      checked={localized?.data?.value || false}
      onChange={(e, v) =>
        onChange(
          { ...localized.data, value: v, epNb: epNb },
          data.id,
          localized.index >= 0 ? localized.index : value.length
        )
      }
      control={<Switch />}
      label=""
    />
  );
});

export default MetadataInputBoolMultiLocalized;
